import { Component, ViewChild, OnInit, TemplateRef, Pipe, PipeTransform } from '@angular/core';
import { UserService } from '../../services/user.service';
import { Seguimiento_expediente } from '../../models/seguimiento_expediente.model';
import { MatDialog, MatSnackBar, _MatFormFieldMixinBase, MatPaginator, MatSort } from '@angular/material';
import { PerfilComponent } from './../perfil/perfil.component';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { Router, ActivatedRoute, Params } from '@angular/router'
import { format } from 'util';
import { NgxSpinnerService } from 'ngx-spinner';
import { registerLocaleData } from '@angular/common';
import es from '@angular/common/locales/es';
import { MatStepper } from '@angular/material/stepper';
import { MatTableDataSource } from '@angular/material';
import { Seguimiento_exp_Service } from 'src/app/services/seguimiento_exp.service';
import { RutValidator } from 'ng2-rut';
import { Acta_expediente } from 'src/app/models/acta_expediente.model';
import { Solicitante_expediente } from 'src/app/models/solicitante_expediente.model';
import { GLOBAL } from 'src/app/services/global';


declare var jQuery: any;
declare var $: any;

@Component({
    selector: "page-seguimiento_expediente",
    templateUrl: "./seguimiento_expediente.component.html",
    styleUrls: ["./seguimiento_expediente.component.css"],
    providers: [UserService, FormService, Seguimiento_exp_Service]
})

export class Seguimiento_expedienteComponent {

    public nombreMuni = GLOBAL.nombreMuni;
    public web = GLOBAL.web;
    public footer = GLOBAL.footer;


    @ViewChild('openModalExp') openModalExp: TemplateRef<any>;
    @ViewChild('openModal') openModal: TemplateRef<any>;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    public solicitudes;
    public seguim_exp: Seguimiento_expediente;
    public acta: Acta_expediente;
    public solicitante: Solicitante_expediente;

    displayedColumns: string[] = ['solicitud', 'expediente', 'fecha_solicitud', 'departamento', 'estado', 'detalle'];
    dataSource = new MatTableDataSource<Solicitante_expediente>();

    public arquit;
    public colorarquit;
    public searchText
    public temp_dir = "a";
    public isopen = false;
    public rut_solic;
    public informacion;
    matcher = new FormService();
    //public licitaciones = [];
    public rows = [];
    public actualRow;
    public seguim_exped = [];
    public panelobs;
    public observ;
    public isDisabled;
    public p: number = 1;
    public departamento;

    // displayedColumns: string[] = ['select', 'rut', 'departamento'];
    //dataSource = new MatTableDataSource<PeriodicElement>(this.seguim_exped);


    public urb = false;
    public edif = false;
    public recep = false;
    public sol_exp;
    public anio;
    public numero;
    public arquitecto = false;
    public rechazada = false;
    public estatus = false;
    public titulo;
    public estatus_aprob = false
    public fechaacta = false
    public colorobserv;
    public obser;
    public estadocolor
    public letracolor
    public fechavisita
    public fechacolor
    public estadofecha
    public rut;

    constructor(private _route: ActivatedRoute, private _router: Router, private _formBuilder: FormBuilder, private _userService: UserService, private spinner: NgxSpinnerService, private dialog: MatDialog, private _formService: FormService, public _expService: Seguimiento_exp_Service, private snackBar: MatSnackBar) {
        this.seguim_exp = { num_solicitud: '', expediente: '', tipo: '', rol_propiedad: '', direccion: '', direccion_edif: '', fecha_ingreso: null, estado: '', descripcion: '', nombre_arquitecto: '', fono_arquitecto: '', email_arquitecto: '', fecha_acta: null, plazo_maximo: '', fecha_notificacion: null, fecha_ingreso_acta: null, numero_oficio: '', fecha_oficio: null, fecha_aprobacion_dom: null, fecha_aprobacion: null, numero_aprobacion: '', fecha_visita_terreno: null, vivienda_altura: '', estado_calculo_derechos: '', recordId: '' };
        // this.solicitante = { rut: '', departamento: '', numero: '' }

        this.informacion = JSON.parse(sessionStorage.getItem("identity-domCloud"));
        this.rut_solic = this.informacion.rut + "-" + this.informacion.dv;
        this.rut = this.rut_solic;

        if (!JSON.parse(localStorage.getItem("solicitud_exp"))) {
            localStorage.setItem("solicitud_exp", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("solicitud_exp"));
        }
        this.get_solicitudes(this.rut);

        registerLocaleData(es)


    }
    pad_with_zeroes(number, length) {

        var my_string = '' + number;
        while (my_string.length < length) {
            my_string = '0' + my_string;
        }

        return my_string;

    }

    getCleanedString(cadena) {
        // Definimos los caracteres que queremos eliminar
        let specialChars = "!@#$^&%*()+=-[]\/{}|:<>?,.";

        // Los eliminamos todos
        for (let i = 0; i < specialChars.length; i++) {
            cadena = cadena.replace(new RegExp("\\" + specialChars[i], 'gi'), '');
        }
        // Lo queremos devolver limpio en mayuscula
        cadena = cadena.toLowerCase();
        // Quitamos espacios y los sustituimos por _ porque nos gusta mas asi
        // cadena = cadena.replace(/ /g,"_");
        // Quitamos acentos y "ñ". Fijate en que va sin comillas el primer parametro
        cadena = cadena.replace(/á/gi, "a");
        cadena = cadena.replace(/é/gi, "e");
        cadena = cadena.replace(/í/gi, "i");
        cadena = cadena.replace(/ó/gi, "o");
        cadena = cadena.replace(/ú/gi, "u");
        cadena = cadena.replace(/ñ/gi, "n");
        cadena = cadena.toUpperCase();
        return cadena;
    }
    ngOnInit() {
        //this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
    }
    ngAfterViewInit() {
        this.dataSource.sort = this.sort;
    }
    get_solicitudes(rut) {

        this.spinner.show()
        this._expService.getSolicitudes(rut).subscribe(
            response => {

                if (response.message) {
                    this.dialog.open(this.openModal);
                    //alert("El Rut que estas buscando no existe en los registros");
                    this.spinner.hide();
                } else {
                    this.solicitudes = response.solicitudes;
                    this.dataSource = this.solicitudes;


                    this.spinner.hide()

                }
            },
            error => {
                console.log(error)
                this.spinner.hide();
            }
        )
    }

    get_solicitud(sol) {
        this.spinner.show()
        var departamento = sol.departamento;
        if ((departamento == 'URB') || (departamento == 'RECEP')) {
            var numero = sol.solicitud;
        } else if (departamento == 'EDIF') {
            var numero = sol.expediente;
        }

        this._expService.getExp(this.rut_solic, numero, departamento).subscribe(
            response => {

                if (response.message) {
                    alert("El Rut que estas buscando no existe en los registros");
                    this.spinner.hide();
                } else {

                    if (departamento == 'EDIF') {
                        this.edif = true;
                        this.urb = false;
                        this.recep = false;
                    } else if (departamento == 'URB') {
                        this.edif = false;
                        this.urb = true;
                        this.recep = false;
                    } else if (departamento == 'RECEP') {
                        this.recep = true;
                        this.urb = false;
                        this.edif = false;
                    }
                    this.seguim_exp.num_solicitud = response.num_solicitud ? response.num_solicitud : '';
                    this.seguim_exp.expediente = response.expediente ? response.expediente : '';

                    localStorage.setItem("solicitud_exp", JSON.stringify([]));
                    this.actualRow = localStorage.getItem("solicitud_exp");
                    this.rows = JSON.parse(this.actualRow);
                    this.rows = this.rows.concat({
                        solicitud: this.seguim_exp.num_solicitud
                    })
                    localStorage.setItem("solicitud_exp", JSON.stringify(this.rows));
                    this.seguim_exp.tipo = response.tipo ? response.tipo : '';
                    this.seguim_exp.rol_propiedad = response.rol_propiedad ? response.rol_propiedad : '';
                    this.seguim_exp.direccion = response.direccion ? response.direccion : '';
                    this.seguim_exp.direccion_edif = response.direccion_edif ? response.direccion_edif : '';
                    this.seguim_exp.fecha_ingreso = response.fecha_ingreso ? response.fecha_ingreso : '';
                    this.seguim_exp.estado = response.estado ? response.estado : '';

                    if ((departamento == 'URB') || (departamento == 'RECEP')) {
                        if ((this.seguim_exp.estado == '0') || (this.seguim_exp.estado == '1') || (this.seguim_exp.estado == '2') || (this.seguim_exp.estado == '5') || (this.seguim_exp.estado == '8') || (this.seguim_exp.estado == '9')) {
                            this.seguim_exp.descripcion = response.descripcion ? response.descripcion : '';
                        } else {
                            this.seguim_exp.descripcion = 'EN PROCESO';
                        }
                    } else if (departamento == 'EDIF') {
                        if ((this.seguim_exp.estado == '7') || (this.seguim_exp.estado == '8')) {
                            this.seguim_exp.descripcion = 'APROBADO';
                        } else if ((this.seguim_exp.estado == '0') || (this.seguim_exp.estado == '1') || (this.seguim_exp.estado == '2') || (this.seguim_exp.estado == '5')) {
                            this.seguim_exp.descripcion = response.descripcion ? response.descripcion : '';
                        } else if (this.seguim_exp.estado == '9') {
                            this.seguim_exp.descripcion = 'RECHAZADO';
                        } else {
                            this.seguim_exp.descripcion = 'EN PROCESO';
                        }
                    }
                    this.seguim_exp.nombre_arquitecto = response.nombre_arquitecto ? response.nombre_arquitecto : '';

                    if (!(this.seguim_exp.nombre_arquitecto)) {
                        this.arquitecto = false;
                        this.arquit = "#7d7d7d";
                        this.colorarquit = "black";
                    } else {
                        this.arquitecto = true;
                        this.arquit = "#009abb";
                        this.colorarquit = "oldlace";
                    }
                    this.seguim_exp.fono_arquitecto = response.fono_arquitecto ? response.fono_arquitecto : '';
                    this.seguim_exp.email_arquitecto = response.email_arquitecto ? response.email_arquitecto : '';
                    this.seguim_exp.fecha_acta = response.fecha_acta ? response.fecha_acta : null;

                    if (!(this.seguim_exp.fecha_acta) || (this.seguim_exp.fecha_acta == null)) {
                        this.fechaacta = false;
                        this.obser = "#7d7d7d"
                        this.colorobserv = "black";

                    } else {
                        this.fechaacta = true;
                        this.obser = "#009abb"
                        this.colorobserv = "oldlace";

                    }
                    this.seguim_exp.plazo_maximo = response.plazo_maximo ? response.plazo_maximo : '';
                    this.seguim_exp.fecha_notificacion = response.fecha_notificacion ? response.fecha_notificacion : '';
                    this.seguim_exp.fecha_ingreso_acta = response.fecha_ingreso_acta ? response.fecha_ingreso_acta : '';
                    this.seguim_exp.numero_oficio = response.numero_oficio ? response.numero_oficio : '';
                    this.seguim_exp.fecha_oficio = response.fecha_oficio ? response.fecha_oficio : '';
                    this.seguim_exp.fecha_aprobacion_dom = response.fecha_aprobacion_dom ? response.fecha_aprobacion_dom : '';
                    if (!(this.seguim_exp.numero_oficio) || (this.seguim_exp.estado == '9')) {
                        this.rechazada = true;
                        this.titulo = 'RECHAZADA';
                        this.letracolor = "oldlace";
                        this.estadocolor = '#009abb';
                    } else if (this.seguim_exp.estado == '0') {
                        this.estatus = false;
                        this.titulo = 'ANULADA';
                        this.letracolor = "black";
                        this.estadocolor = '#7d7d7d';

                    } else if ((!(this.seguim_exp.fecha_aprobacion_dom)) && (!(this.seguim_exp.estado == '0'))) {
                        this.estatus = true;
                        this.titulo = 'EN PROCESO';
                        this.letracolor = "oldlace";
                        this.estadocolor = '#009abb';
                    } else if (this.seguim_exp.estado == '8') {
                        this.estatus_aprob = true;
                        this.titulo = 'APROBADA';
                        this.letracolor = "oldlace";
                        this.estadocolor = '#009abb';
                    }

                    this.seguim_exp.fecha_aprobacion = response.fecha_aprobacion ? response.fecha_aprobacion : '';
                    this.seguim_exp.numero_aprobacion = response.numero_aprobacion ? response.numero_aprobacion : 0;
                    this.seguim_exp.fecha_visita_terreno = response.fecha_visita_terreno ? response.fecha_visita_terreno : '';
                    if (departamento == 'RECEP') {

                        if (!(this.seguim_exp.fecha_visita_terreno)) {
                            this.fechavisita = false;
                            this.fechacolor = "black";
                            this.estadofecha = '#7d7d7d';
                        } else {
                            this.fechavisita = true;
                            this.fechacolor = "oldlace";
                            this.estadofecha = '#009abb';
                        }
                    }
                    this.seguim_exp.vivienda_altura = response.vivienda_altura ? response.vivienda_altura : '';
                    this.seguim_exp.estado_calculo_derechos = response.estado_calculo_derechos ? response.estado_calculo_derechos : '';

                    this.seguim_exp.vivienda_altura = response.vivienda_altura ? response.vivienda_altura : '';
                    this.seguim_exp.estado_calculo_derechos = response.estado_calculo_derechos ? response.estado_calculo_derechos : '';
                    this.spinner.hide();
                    this.dialog.open(this.openModalExp);
                }
            },
            error => {
                console.log(error)
                this.spinner.hide();
            }
        )

    }
    getActa(exp) {
        this.spinner.show()
        this._expService.getActa(exp).subscribe(
            response => {
                if (response.message) {
                    this.cleanData();
                    alert("El número de solicitud que estas buscando no existe en los registros");
                    this.spinner.hide();
                } else {
                    this.acta.id_solicitud = response.id_solicitud ? response.id_solicitud : '';
                    this.acta.fecha_acta = response.fecha_acta ? response.fecha_acta : '';
                    this.acta.encabezado = response.encabezado ? response.encabezado : '';
                    this.acta.notas = response.notas ? response.notas : '';
                    this.acta.notas1 = response.notas1 ? response.notas1 : '';
                    this.spinner.hide()
                }
            },
            error => {
                console.log(error)
                this.spinner.hide()
            }
        )
    }


    ngDoCheck() {
        // this.lSolicitud = this.firstFormGroup.get('departamento').value;
    }

    cleanData() {
        this.seguim_exp = { num_solicitud: '', expediente: '', tipo: '', rol_propiedad: '', direccion: '', direccion_edif: '', fecha_ingreso: null, estado: '', descripcion: '', nombre_arquitecto: '', fono_arquitecto: '', email_arquitecto: '', fecha_acta: null, plazo_maximo: '', fecha_notificacion: null, fecha_ingreso_acta: null, numero_oficio: '', fecha_oficio: null, fecha_aprobacion_dom: null, fecha_aprobacion: null, numero_aprobacion: '', fecha_visita_terreno: null, vivienda_altura: '', estado_calculo_derechos: '', recordId: '' };
    }

    inicio() {
        this._router.navigate(['/']);
    }

    perfil() {
        this.dialog.open(PerfilComponent)
    }

    logout() {
        sessionStorage.removeItem("identity-domCloud");
        sessionStorage.removeItem("token-domCloud");
        this.snackBar.open("Se ha cerrado sesión", "Cerrar", {
            duration: 3000,
        });
        this._router.navigate(['/']);
    }
}

